/**
 * Öffnet alle Panels nach dem Ynfinite-Init:
 * - .yn-accordions--open auf dem Accordion-Root
 * - .accordions--open auf dem Wrapper (öffnet alle inneren Accordions)
 * is-active allein reicht nicht – accordion-js setzt height: 0 beim Start.
 */
export const ynAccordionsOpen = () => {
	const containers = new Set([
		...document.querySelectorAll('.yn-accordions--open'),
		...document.querySelectorAll('.accordions--open .yn-accordions'),
	])

	containers.forEach((container) => {
		const instance = container._accordion
		if (!instance) return

		container.querySelectorAll('.yn-accordion').forEach((item, index) => {
			if (!item.classList.contains('is-active')) {
				instance.open(index)
			}
		})
	})
}

/**
 * Branchen-Teaser: erstes Accordion öffnen und Bild in .accordions__image syncen.
 */
export const branchenAccordionImages = () => {
	const section = document.querySelector('.teaser--branchen')
	if (!section) return

	const accordionRoot = section.querySelector('.yn-accordions')
	const imageItems = [...section.querySelectorAll('.accordions__image-item')]
	if (!accordionRoot || !imageItems.length) return

	const setActiveImage = (index) => {
		const hasImage = imageItems.some((item) => item.dataset.index === String(index))
		if (!hasImage) return

		imageItems.forEach((item) => {
			item.classList.toggle('is-active', item.dataset.index === String(index))
		})
	}

	const syncFromAccordion = () => {
		const active = accordionRoot.querySelector('.yn-accordion.is-active')
		if (!active) return

		const index = active.querySelector('.yn-accordion__header')?.getAttribute('index')
		if (index != null) setActiveImage(index)
	}

	const instance = accordionRoot._accordion
	if (instance) instance.open(0)
	setActiveImage(0)

	accordionRoot.querySelectorAll('.yn-accordion').forEach((item) => {
		new MutationObserver(syncFromAccordion).observe(item, {
			attributes: true,
			attributeFilter: ['class'],
		})
	})
}
